// extracted by mini-css-extract-plugin
export var bottle = "our-kombucha-module--bottle--+r8er";
export var bottle_copy = "our-kombucha-module--bottle_copy--1bvtD";
export var bottle_img = "our-kombucha-module--bottle_img--DC66x";
export var bottles_container = "our-kombucha-module--bottles_container--0iC5Z";
export var core_bg = "our-kombucha-module--core_bg--2NkVq";
export var core_container = "our-kombucha-module--core_container--dIKyX";
export var core_flavor = "our-kombucha-module--core_flavor--mcIaW";
export var core_flavor_img = "our-kombucha-module--core_flavor_img--8N7oS";
export var header_bg = "our-kombucha-module--header_bg--c4usl";
export var our_kombucha_bottles = "our-kombucha-module--our_kombucha_bottles--NP7Ee";
export var our_kombucha_tap = "our-kombucha-module--our_kombucha_tap--mInzG";
export var seasonal_container = "our-kombucha-module--seasonal_container--aSs0t";